function pageGA(logMessage, gaName, url) {
    if (window.ga) {
        window.ga('send', 'event', '首頁3', '點擊', gaName);
    }
    if (window.eHanlin && window.eHanlin.ab && window.eHanlin.ab.peterImageLog) {
        window.eHanlin.ab.peterImageLog(logMessage);
    }

    if (url && url !== "") {
        window.location.href = url
    }
}

// cookie
function checkCookie(){
    var cookie = getCookie("eh-expires")
    var cookieWrap  = document.querySelector('.cookie');

    if (cookie !== undefined && Number.isInteger(parseInt(cookie)) && parseInt(cookie) > Date.now()){
        setCookie();
    }else{
        cookieWrap.classList.remove("dn")
        setCookie();
    }
}

checkCookie();

function setCookie() {
    var btnAgree  = document.querySelector('.btn-agree-cookie');
    var cookieWrap  = document.querySelector('.cookie');

    btnAgree.addEventListener("click",function(){
        cookieWrap.classList.add("dn")
        var d = new Date();
        var year = d.getFullYear();
        var month = d.getMonth();
        var day = d.getDate();

        var fulldate = new Date(year + 3, month, day);
        document.cookie = "eh-expires=" + fulldate.getTime() + ";path=/";
    })
}

function getCookie(name){
    var arr = document.cookie.match(new RegExp("(^| )" + name + "=([^;]*)(;|$)"));
    if (arr != null) return unescape(arr[2]); return null;

}

//navbar
var toggleClass = document.querySelectorAll('[data-toggle-class]');
var className;
var targetClick;
var targetClass;
var targetElements;
var clickEvent;
if (toggleClass) {
    for(i = 0 ; i < toggleClass.length ; i += 1) {
        toggleClass[i].addEventListener('click', function(event) {
            if(window.innerWidth <= 991){
                className = this.getAttribute('data-toggle-class');
                targetClick = this.getAttribute('data-target').slice(1);
                targetClass = targetClick.split('-')[0];
                targetElements = document.getElementsByClassName(targetClass);
                clickEvent = window.event;
                if(clickEvent === event){
                    if(document.getElementById(targetClick).classList.contains(className) == true){
                        document.getElementById(targetClick).classList.toggle(className);
                        event.stopPropagation();
                    }
                    else if(document.getElementById(targetClick).classList.contains(className) == false){
                        for(i = 0 ; i < targetElements.length ; i++ ){
                                targetElements[i].classList.remove(className);
                        }
                        document.getElementById(targetClick).classList.toggle(className);
                        event.stopPropagation();
                    }
                }
            }
        });
    }
}
var removeNavbar = document.getElementsByClassName('navbarDropdown');
var removeSub = document.getElementsByClassName('subDropdown');
document.querySelector('#hamBtn').addEventListener("click",function(){
    for(i = 0 ; i < removeNavbar.length ; i++ ) {
        removeNavbar[i].classList.remove('show');
    }
    for(i = 0 ; i < removeSub.length ; i++ ) {
        removeSub[i].classList.remove('show');
    }
});
var removeHam = document.getElementById('navbarNavDropdown');
function removeNavBarToggle(){
    removeHam.classList.remove('show');
    for(i = 0 ; i < removeNavbar.length ; i++ ) {
        removeNavbar[i].classList.remove('show');
    }
    for(i = 0 ; i < removeSub.length ; i++ ) {
        removeSub[i].classList.remove('show');
    }
}
window.onresize = function(){
    if(window.innerWidth > 991){
        removeNavBarToggle();
    }
};

//load Json
function loadJSON(path, success, error){
    var xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function()
    {
        if (xhr.readyState === XMLHttpRequest.DONE) {
            if (xhr.status === 200) {
                if (success)
                    success(JSON.parse(xhr.responseText));
            } else {
                if (error)
                    error(xhr);
            }
        }
    };
    xhr.open("GET", path, true);
    xhr.send();
}

var i18nMap = function(list, idKey, nameKey){
    var map = {};
    for(i=0 ; i < list.length ; i++){
        map[list[i][idKey]] = list[i][nameKey];
    }
    return map;
}
var teamI18n;
var teacherI18n;


// 讀表 (要顯示的課程)
var wantShowList = new Object();
// dataprovider
var productData = {};
window.eHanlin.dataprovider.index.stars(function(data){
    productData = data;
    // Stars
    for(i=0 ; i < productData.product.length ; i++){
        if(productData.product[i].cover){
            productData.product[i].cover = productData.product[i].cover.coffeeReplace(window.eHanlin.platform_env);
        }
        else{
            productData.product[i].cover = window.eHanlin.platform_env.cdn+'/web/course-pic/course-fail.png';
        }
    }
    teamI18n = i18nMap(productData.team, 'id', 'name');
    teacherI18n = i18nMap(productData.teacher, 'id', 'name');
    loadJSON("./js/recommend.json",
    function(data) {
        wantShowList = data;
        for(i=0 ; i< wantShowList.length ; i++){
            wantShowList[i] = wantShowList[i].filter(Boolean);
        }
        appendProduct(0);
        appendProduct(1);
        appendProduct(2);
    },
    function(xhr) { console.error(xhr); }
    );

});

window.eHanlin.dataprovider.index.banner(function(data){
    // Banner
    data.sort(function(a, b){
        return a.order - b.order;
    })
    document.querySelector('.top-slider').innerHTML = '';
    for (i = 0; i < data.length ; i++) {
        var ga = "ga('send', 'event', '首頁', 'bannerClick', '"+data[i]._id+"');"
        if(data[i].imgUrl.indexOf("public.ehanlin.com.tw")==-1){
            document.querySelector('.top-slider').innerHTML += '<div class="slider-item"><a href="'+data[i].href+'" target="_blank" onclick="'+ga+'"><img src="https://d1jme9zqkbqig.cloudfront.net/'+data[i]._id+'.png"></a></div>';
        }else{
            document.querySelector('.top-slider').innerHTML += '<div class="slider-item"><a href="'+data[i].href+'" target="_blank" onclick="'+ga+'"><img src="'+data[i].imgUrl+'"></a></div>';
        }
    }
    var topSlider = tns({
        container: '.top-slider',
        loop: true,
        items: 1,
        slideBy: 'page',
        gutter: "12",
        nav: true,
        navPosition: "buttom",
        controlsContainer: ".top-slider-controls",
        autoplay: true,
        speed: 600,
        autoplayTimeout: 5000,
        autoplayButtonOutput: false,
        lazyload: true,
        mouseDrag: true,
    });
});

window.eHanlin.dataprovider.index.story(function(data){
    // Storys
    var storyArr = new Object();
    loadJSON("./js/storys.json",
        function(data) {
            storyArr = data;
            for(i=0 ; i < storyArr.result.length ; i++){
                if(storyArr.result[i].img){
                    storyArr.result[i].img = storyArr.result[i].img.coffeeReplace(window.eHanlin.platform_env);
                }
                else{
                    storyArr.result[i].img = window.eHanlin.platform_env.cdn+'/web/experience/somebody_v1.jpg';
                }
            }
            appendStorys();},
        function(xhr) { console.error(xhr); }
    );
    function appendStorys() {
        for (i = 0; i < storyArr.result.length && i < 20 ; i++) {
            if(storyArr.result[i].awards){
                document.querySelector("#storysSlot").innerHTML += '<div class="slider-items"><div class="student-card special"><div class="student-infos"><img src="'+storyArr.result[i].img+'" alt="'+storyArr.result[i].name+'"><img class="award-winner" src="./img/icon-crown.svg"><div class="main-infos"><div class="student-name">'+storyArr.result[i].name+'</div><div class="student-school">'+storyArr.result[i].school+'</div></div><div class="student-score">'+storyArr.result[i].score+'</div><hr><p>'+storyArr.result[i].story+'</p></div></div></div>';
            }
            else{
                document.querySelector("#storysSlot").innerHTML += '<div class="slider-items"><div class="student-card"><div class="student-infos"><img src="'+storyArr.result[i].img+'" alt="'+storyArr.result[i].name+'"><div class="main-infos"><div class="student-name mt-1">'+storyArr.result[i].name+'</div><div class="student-school">'+storyArr.result[i].school+'</div></div><hr><p>'+storyArr.result[i].story+'</p></div></div></div>';
            }
        }
        var cardSlider = tns({
            container: '.card-slider',
            loop: true,
            items: 1,
            slideBy: 'page',
            nav: true,
            navPosition: "bottom",
            controlsContainer: ".card-slider-controls",
            autoplay: true,
            speed: 600,
            autoplayTimeout: 5000,
            autoplayButtonOutput: false,
            mouseDrag: true,
            lazyload: true,
            responsive: {
                1200: {
                        items: 4,
                },
                991: {
                        items: 3,
                },
                768: {
                        items: 2,
                }
            }
        });
    };
});


// 使用資料方法
var gradeName = ['es','jhs','shs'];
function appendProduct(num) {
    var statusTagDisplay = 'dn';
    var statusTagText = '';
    var productPrice = '';
    var originalPrice = '';
    var originalPriceDisplay = 'dn';
    var productPriceSale = '';

    if(!Array.prototype.find){
        Array.prototype.find = function(callback) {
            return callback && (this.filter(callback)|| [])[0];
        };
    }
    document.getElementById(gradeName[num]+'Courses').innerHTML = '';
    for(var i=0 ; i < wantShowList[num].length ; i++){
        var found = productData.product.find(function(element) {return element.id == wantShowList[num][i]});
        if(found){
            statusTagDisplay = 'dn';
            if(found.new){
                statusTagText = 'NEW';
                statusTagDisplay = '';
            }
            if(found.star){
                statusTagText = 'HOT';
                statusTagDisplay = '';
            }
            productPrice = '$'+found.sell;
            if(found.discount){
                originalPriceDisplay = '';
                productPriceSale = 'on-sale';
                originalPrice = '$'+found.origin;
                productPrice = '$'+found.sell;
            }
            var teacherGroup = '';
            var team = '';
            if(found.team && found.team.length > 0){
                team = teamI18n[found.team[0]];
            }
            var teachers = '';
            if(found.teacher && found.teacher.length > 0){
                for(j = 0 ; j < found.teacher.length ; j++){
                    teachers = teachers + teacherI18n[found.teacher[j]] + '、';
                }
            }
            teachers = teachers.substr(0, teachers.length - 1);
            if(team !== '' && teachers !== ''){
                teachers = '(' + teachers + ')';
            }
            teacherGroup = team + teachers ;
            if(teacherGroup.length > 15){
                teacherGroup = teacherGroup.substr(0,15) + '...'
            }
            document.getElementById(gradeName[num]+'Courses').innerHTML +=
                '<div class="product-card"><a class="card-tracker" href="/app/online-showcase/product-info.html?id=' + found.id + '" target="_blank"></a><div class="card-infos infos-up"><div class="cover-img"><img src="'+found.cover+'"></div><div class="status-tag '+statusTagDisplay+'">'+statusTagText+'</div><div class="grade-tag">'+found.label+'</div><div class="btn-container"><a class="hover-btn btn-blue" href="/app/online-showcase/product-info.html?id=' + found.id + '" target="_blank">了解更多</a></div></div><div class="card-infos infos-down"><div class="product-infos"><div class="product-name">'+found.name+'</div><div class="product-teacher">'+teacherGroup+'</div></div><div class="product-sub-price"><div class="original-price '+originalPriceDisplay+'">'+originalPrice+'</div><div class="product-price '+productPriceSale+'">'+productPrice+'</div></div></div></div>';
        }
    }
}

// scroll to top
document.querySelector('.totop').addEventListener("click",function(){
    document.body.scrollIntoView({behavior: 'smooth', block: 'start'});
    document.documentElement.scrollIntoView({behavior: 'smooth', block: 'start'});
});
window.onscroll = function() {
    if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
        document.querySelector('.totop').style.opacity = "1";
    } else {
        document.querySelector('.totop').style.opacity = "0"
    }
};


//----- daily question--/
//----- set dailyquestion iframe ------//
// 短題目 id：552f3ffc192c5e2a78827b52
// 長題目 id：54b88e5f192c5e0b104978cd

//init iframe
(async function(clientAPI){
    //取得每日一題資料
    const currentDate = new Date();
    const dataName = currentDate.toDateString().replaceAll(' ', '-');
    const dailyQuestionUrl = 'https://storage.googleapis.com/tutor-test-events/event/dailyquestion/' + dataName + '.json';
    let questionData = '';
    try{
        questionData = await fetch(dailyQuestionUrl).then(response => response.json());
    }catch (err){
        questionData = await fetch('./js/default-dailyquestion.json').then(response => response.json());
    }

    //取得推薦產品年段篩選條件
    let filterItem = questionData['sales plan id'];
    if( filterItem.length === 0){
        filterItem = "ES&all&all&ET";
    }
    const filterItemArray = filterItem.split('&');
    const filterItemTitle = ['grade', 'volume', 'category'];
    const fiterObject = {};
    for (let i = 1; i < filterItemArray.length; i++) {
        if ( filterItemArray[i] && filterItemArray[i] !== 'all' ) {
            fiterObject[filterItemTitle[i-1]] = filterItemArray[i];
        }
    }
    //取得推薦產品科目篩選條件
    let subjectFilter = questionData['推廣產品科目'];
    if( subjectFilter.length === 0){
        subjectFilter = "國文&全科";
    }
    const subjectFilterArray = subjectFilter.split('&');

    //domain設定
    const host = window.location.hostname;
    const protocol = window.location.protocol;
    let baseUrl = protocol + "//" + host;

    //分開host路徑 獲取資料
    let fullProductData;
    if (host.toLowerCase() ==='www.tbbt.com.tw' || host.toLowerCase() ==='www.ehanlin.com.tw'){
        fullProductData = await fetch(baseUrl + '/online-showcase/products?'+ new URLSearchParams({
            'system': filterItemArray[0],
        })).then(response => response.json());
    } else{
        //測試用資料
        fullProductData = await fetch('./js/test.json').then(response => response.json()).then(data => data);
    }
    let productData = fullProductData.product;

    //篩選產品類別
    for(const [key, value] of Object.entries(fiterObject)){
        productData = productData.filter(function(element) { return element[key].includes(value) });
    }
    //篩選產品科目
    let sliderData = [];
    for(let i = 0 ; i < subjectFilterArray.length ; i++){
        sliderData.push(productData.filter(({name}) => name.includes(subjectFilterArray[i])));
        sliderData = sliderData.flat();
    }

    //在slider中加入產品
    if(sliderData.length > 0){
        for(let i in sliderData){
            let setImg = sliderData[i].cover;
            const type = sliderData[i].type;
            let setUrl;
            //設定圖片位置
            if (host === 'www.ehanlin.com.tw'){
                setImg = encodeURI(setImg.replace('#{cdn}', 'https://public.ehanlin.com.tw'));
            }else {
                setImg = encodeURI(setImg.replace('#{cdn}', 'https://ehanlin-web-public-resource.s3-ap-northeast-1.amazonaws.com'));
                //順便重置連結 方便測試用
                baseUrl = 'https://www.tbbt.com.tw';
            }
            //設定鏈結
            if(type === 'ONLINE'){
                setUrl = encodeURI(baseUrl + '/app/online-showcase/product-info.html?id=' + sliderData[i].id);
            }else{
                setUrl = encodeURI(baseUrl + '/app/online-showcase/product-package.html?id=' + sliderData[i].id);
            }
            $(".responsive").slick('slickAdd', `<div class="slider-dailyQuestion-link">
            <div class="slider-dailyQuestion-btnContainer">
            <a class="slider-dailyQuestion-btn hover-btn btn-orange">免費開通</a>
            <a class="slider-dailyQuestion-btn hover-btn btn-blue" href=${setUrl}>查看課程資訊</a>
            </div>
            <img class="slider-dailyQuestion-img" src=${setImg} alt="">
            </div>`);
        }
        $('.responsive').slick('slickRemove', 0);
    }

    //設定輪播免費開通按鈕
    $('.slider-dailyQuestion-btn').filter('.btn-orange').click(function(){
        sessionStorage.setItem('redirect', baseUrl + '/app/online-trial/trial-list.html?system=' + filterItemArray[0]);
        window.location.href = "/app/member-center/login.html";
    });
    //設定免費通按鈕
    $('#btn-freeCourse').attr('href', `${baseUrl}/app/online-trial/trial-list.html?system=${filterItemArray[0]}`);
    //設定更多課程按鈕
    $('#btn-moreCourse').attr('href', `${baseUrl}/app/online-showcase/product-list.html#${filterItemArray[0]}&all&all&all`);

    //-----init dailyquestion iframe----//
    const dailyQuestionContext = clientAPI.getContext(questionData['題目ID']);
    let dailyQuestionIframe = dailyQuestionContext.container;
    let studentAnswer = {};

    dailyQuestionIframe.width = "100%";
    clientAPI
        .ready( dailyQuestionIframe )
        .then(function( initFrame ){
            initFrame().then(function(){
                clientAPI.setup(dailyQuestionIframe, {
                    externalComponents:{
                        keyword:{
                            width:550
                        },
                        answerGuide:{
                            width:1000
                        },
                        keyboard:{
                            width:350
                        }
                    },
                    data: {
                        showQuestion:true,
                        showAnalysis:true,
                        showAnalysisText:false,
                        showAnalysisImage:false,
                        showAnalysisButton:false,
                        showItemNumber:false,
                    },
                    eachData: {
                        showExpandButton:false,
                        enabledOption:true,
                        showCorrectness:false,
                        showAnswer:false,
                        showOption:true,
                        showAnswerButton:false,
                        showStarButton:false,
                        showMarkButton:false,
                        showMarkDelButton:false,
                    },
                });

                clientAPI.autoSize( dailyQuestionIframe, true );

                //先取的所有答題的題目
                clientAPI.on( dailyQuestionIframe, 'answer', function(evt, data){
                    studentAnswer[data.questionIndex] = data.answer;
                });
            });
        });

    const containerQu = document.getElementById("iframeContainer")
    containerQu.appendChild( dailyQuestionIframe );

    //加入標籤
    const tagList = [];
    tagList.push(questionData['年段']);
    tagList.push(questionData['科目']);
    if (questionData['素養題'] !== false) {
        tagList.push('素養題');
    }

    const quizTagList = document.querySelector('.quiz-tag-list');
    for( let i of tagList){
        let tag = document.createElement('p');
        tag.innerHTML = i;
        tag.setAttribute('class', 'quiz-tag-item');
        quizTagList.appendChild(tag);
    }

    //點選字的大小決定字體大小
    const questionSizeList = document.getElementsByName("dailyQSize");
    for(let element of questionSizeList){
        element.addEventListener('click', () => {
            const elementFrontsize = element.getAttribute("value");
            clientAPI.setup(dailyQuestionIframe, {
                data: {
                    textScale: elementFrontsize
                }
            })
            console.log(elementFrontsize);
        })
    }

    //增加字體大小按鈕
    const wordUpper = document.getElementById("wordSizeUpper")
    wordUpper.addEventListener('click', () => {
        for (let i=0 ; i < questionSizeList.length -1; i++){
            if (questionSizeList[i].checked){
                questionSizeList[i + 1].checked = true;
                questionClientAPI.setup(dailyQuestionIframe, {
                    data: {
                        textScale: questionSizeList[i + 1].getAttribute("value")
                    }
                });
                break;
            }
        }
    })

    //縮小字體大小按鈕
    const wordLower = document.getElementById("wordSizeLower")
    wordLower.addEventListener('click', () => {
        for (let i=1 ; i < questionSizeList.length; i++){
            if (questionSizeList[i].checked){
                questionSizeList[i - 1].checked = true;
                questionClientAPI.setup(dailyQuestionIframe, {
                    data: {
                        textScale: questionSizeList[i - 1].value
                    }
                });
                break;
            }
        }
    })

    //回傳答案是否正確 同時呈現解析
    async function checkAnsCorrect(){
        clientAPI.setup(dailyQuestionIframe, {
            data: {
                showAnalysisText:true,
                showAnalysisImage:true,
            },eachData:{
                showAnswer:true,
                enabledOption:true,
                showCorrectness:true,
            }
        });

        //確認答案是否全部都正確用
        return  await dailyQuestionContext.checkAnswer().then(async function(data) {
            for(let i = 0; i < data['corrects'].length; i++){
                if(data['corrects'][i][0][0] === false){
                    return false;
                }
            }
            return true;
        }).catch((err)=> console.log(err))
    }

    //答題確認按鈕
    const checkAnsBtn = document.getElementById("checkAnsBtn");
    let haveChecked = false;
    checkAnsBtn.addEventListener('click', async ()=> {

        const getItem = await dailyQuestionContext.getItemInfo().then(async function(data){
            return data
        }).catch((err)=> console.log(err));
        const itemNum = getItem[0]['result']['0']['itemCount'];

        //第一次確認有沒有沒答題
        if (itemNum !== Object.keys(studentAnswer).length && haveChecked === false){
            $('.alert-stage').addClass('popup-fadeIn')
            haveChecked = true;
        }else{
            //------第二次直接解答並提供解析------/
            const dailyQuestionResult = await checkAnsCorrect();

            //紀錄與回傳結果
            await dailyQStoreAnswerNum(questionData['題目ID'], dailyQuestionResult);
            // 確認答案按鈕 換成 答題狀況按鈕
            $('.quiz-answer-btn').addClass('dn')
            $('.quiz-statistics-btn')
            .removeClass('dn')
            .addClass('btn-clickme-animate')

            //------更改第三頁結果呈現內容------//
            //更改結果圖片
            if(dailyQuestionResult === true){
                $('.result-info-img').attr('src', './img/dailyQuestion/popup-correct.png')
                $('.result-albi')
                .attr('src', './img/dailyQuestion/albi-correct.png')
                .removeClass('incorrect')
                .addClass('correct')

            }
            //答題狀況
            const resultInfo = document.getElementById('result-info')
            const correctResult = await getDailyQAnswerNum(questionData['題目ID']);
            let successNum = correctResult['successCount']
            let totalNum = correctResult['totalCount']
            let successRate = (successNum / totalNum) * 100;
            resultInfo.innerHTML = `${
                //取到小數點後一位
                Math.round(successNum / totalNum * 1000)/10
            }`;

            //-----顯示解析------/
            const quizQuestion = document.getElementsByClassName('quiz-question');
            quizQuestion[0].scrollTo({top: quizQuestion[0].scrollHeight , behavior: 'smooth'});
        }
    })
})(questionClientAPI);

// dailyQuestion（CSS）
$(window).ready(function(){
    // 進入頁面
    pageGA("index3","首頁3","")

    $('#freeTrialLink').click(function (){
        pageGA("免費試用&index=3", "免費試用", "")
    })
    $('#search-productList').click(function () {
        pageGA("課程介紹&index=3","課程介紹", "/app/online-showcase/product-list.html#JS&all&all&all");
    });
    $('#activeRefLink').click(function (){
        pageGA("開通碼開通&index=3", "開通碼開通",'')
    })




    $('#navbar').click(function () {
        pageGA("升學專區&index=3","升學專區", "");
    });

    $('#navbarDropdownMenuLink').click(function () {
        pageGA("活動專區&index=3", "活動專區","");
    });

    $('#registerLink').click(function () {
        pageGA("註冊&index=3", "註冊", "");
    });

    $('#loginLink').click(function () {
        pageGA("登入&index=3", "登入", "");
    });


    $('#activityIntroLink').click(function() {
        pageGA("翰林童話鎮保衛戰&index=3", "翰林童話鎮保衛戰",'')
    })

    $('#learningnotifyLink').click(function() {
        pageGA("學習通知&index=3", "學習通知",'')
    })

    $('#moreEsLink').click(function (){
        pageGA("更多國小課程&index=3", "更多國小課程",'')
    })
    $('#moreJhsLink').click(function() {
        pageGA("更多國中課程&index=3", "更多國中課程",'')
    })
    $('#moreShsLink').click(function(){
        pageGA("更多高中課程&index=3", "更多高中課程",'')
    })
    $('#moreCourseLink').click(function(){
        pageGA("查看更多課程&index=3", "查看更多課程",'')
    })


    $('#keyWordLink').click(function(){
        pageGA("小中高知識點關鍵字&index=3", "小中高知識點關鍵字",'')
    })
    $('#courseUseLink').click(function (){
        pageGA("課程使用說明&index=3", "課程使用說明",'')
    })
    $('#lineInfoLink').click(function() {
        pageGA("學習通知&index=3", "學習通知",'')
    })

    $('#userRankLink').click(function (){
        pageGA("會員等級說明&index=3", '會員等級說明','')
    })

    checkResponsiveState()

    // 挑戰開始按鈕（開始答題）
    $('.start-btn').click(function(){
        $('.start-title').fadeOut()
        $('.start-btn').addClass('btn-fadeout')
        $('.bg-blend').addClass('active')
        $('.start-stage').css('z-index', 1000)
        $('.quiz-stage').removeClass('stage-hide').addClass('stage-ani-show')
    })

    // 答題狀況按鈕（進入結果頁的轉場設定）
    $('.quiz-statistics-btn').click(function(){
        $(this).addClass('btn-fadeout')
        $('.quiz-section').addClass('stage-ani-hide')
        $('.quiz-stage').css('z-index', 1000)
        $('.game-stage').removeClass('start').addClass('end')
        $('.end-stage').removeClass('stage-hide').addClass('stage-ani-show')
    })

    // 引入 slick 輪播套件
    $(".responsive").slick({
        dots: false,
        infinite: true,
        speed: 300,
        // autoplay: true,
        // autoplaySpeed: 5000,
        slidesToShow: 2,
        slidesToScroll: 2,
        responsive: [
        {
            breakpoint: 768,
            settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            variableWidth: true
            }
        },
        ]
    })

    // 點擊 float-btn 後移動到每日一題的位置
    $('.float-btn').click(function(e){
        e.preventDefault()
        $('html,body').animate({
            scrollTop: $('#dailyQuestion').offset().top
        },700)
    })

})

$(window).resize(function(){
    checkResponsiveState()
})

// 確認響應式（RWD）狀態，更換圖片及字體大小設定
function checkResponsiveState(){
    const questionSizeList = document.getElementsByName("dailyQSize");
    if($(window).width() > 992){
        $('.course-title').attr('src','./img/dailyQuestion/course-title-pc.png');
    }else if($(window).width() < 992){
        $('.course-title').attr('src','./img/dailyQuestion/course-title-mobile.png');
    }else if($(window).width() < 576){
        // $('.start-title').attr('src','./img/dailyQuestion/title-mobile.png');
        //set question size radio button value [mobile]
        const frontArr = ['1', '1.1', '1.2', '1.3']
        for (let i=0; i < questionSizeList.length; i++){
            questionSizeList[i].value = frontArr[i];
        }
    }else{
        // $('.start-title').attr('src','./img/dailyQuestion/title.png');

        //set question size radio button value [desktop]
        const frontArr = ['1', '1.2', '1.4', '1.6'];
        for (let i=0; i < questionSizeList.length; i++) {
            questionSizeList[i].value = frontArr[i];
        }
    }
}

// 隱藏 popup modal
$('.alert-continueAnswer-btn').click(function(){
    $('.alert-stage').removeClass('popup-fadeIn')
})
